import { Component, Prop, Vue } from 'vue-property-decorator';
import StrategyCard from '../strategy-card/index.vue';
import { Strategy } from '@/classes/Strategy';

@Component({
  name: 'strategy-deck',
  components: {
    StrategyCard,
  },
})
export default class StrategyDeck extends Vue {

  @Prop()
  public strategies!: Strategy[];

  @Prop()
  public type!: string;

  onStrategySelected(strategy: Strategy) {
    this.$emit('strategySelected', strategy)
  }

  get typeStrategies() {
    return this.strategies.filter((s) => {
      return s.getTypeResults(this.type)[0] != undefined
    })
  }
}
